import { OptionItem, SocialProvider } from "@/models/general";
import { UserSubscription } from "@/models/subscriptionUser";
import { OrganizationUser } from "./organization";

export interface User {
  id: number;
  avatar?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  title: string;
  admin_type: { id: number; name: string; isCMS: boolean };
  country: { id: number; name: string; shortName: string };
  email?: string;
  password: string;
  countryId: number;
  ip: string;
  status: number;
  isNotify: boolean;
  adminTypeId: number;
  company: string;
  is2FA?: boolean;
  phone: string;
  language: string;
  subscriptions: UserSubscription[];
  currency: string;
  invitationCode?: string;
  verified: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  license: UserSubscription;
  guestExpiredTime?: Date;
  isTrial?: boolean;
  isVerifyOrganization?: boolean;
  isAdminOrganization?: boolean;
  isWarningOrganization?: boolean;
  role?: number;
  organization: OrganizationUser;
  isOwner?: boolean;
  permissions?: PermissionMap;
}

export interface PermissionAction {
  create: boolean;
  read: boolean;
  edit: boolean;
  delete: boolean;
}
export type PermissionMap = Record<string, PermissionAction>;

export enum EAdminType {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  USER = 3,
  GUEST = 4,
}
export enum EUserStatus {
  ACTIVE = 1,
  BLOCKED = 2,
}

export enum ETypeEmailBlock {
  EMAIL = 1,
  DOMAIN = 2,
}

export enum ECategoryStatus {
  ACTIVE = 1,
  INACTIVE = 0,
}

export const adminTypes: OptionItem[] = [
  {
    id: EAdminType.ADMIN,
    name: "Admin",
  },
  {
    id: EAdminType.USER,
    name: "User",
  },
];
export const adminAllTypes: OptionItem[] = [
  {
    id: EAdminType.ADMIN,
    name: "Admin",
  },
  {
    id: EAdminType.USER,
    name: "User",
  },
  {
    id: EAdminType.SUPER_ADMIN,
    name: "Super admin",
  },
  {
    id: EAdminType.GUEST,
    name: "Guest",
  },
];

export const adminAllStatus: OptionItem[] = [
  {
    id: EUserStatus.ACTIVE,
    name: "Active",
  },
  {
    id: EUserStatus.BLOCKED,
    name: "Blocked",
  },
];

export const categoryAllStatus: OptionItem[] = [
  {
    id: ECategoryStatus.ACTIVE,
    name: "Active",
  },
  {
    id: ECategoryStatus.INACTIVE,
    name: "Inactive",
  },
];

export const adminAllEmailBlockTypes: OptionItem[] = [
  {
    id: ETypeEmailBlock.EMAIL,
    name: "Email",
  },
  {
    id: ETypeEmailBlock.DOMAIN,
    name: "Domain",
  },
];

export interface LoginData {
  email: string;
  password: string;
  guestId?: number;
}

export interface UserSocialLogin {
  token: string;
  provider: SocialProvider;
  guestId?: number;
}

export interface RegisterData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  countryId: number;
  state?: string;
  isNotify?: boolean;
  company?: string;
  phone?: string;
  guestId?: number;
  invitationCode?: string;
}

export interface ForgotPasswordRequest {
  code: string;
  password: string;
  confirmPassword: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface VerifyCodeRequest {
  code: string;
  type: number;
}

export interface CheckIsValidCode {
  code: string;
  type: number;
}

export interface ForgotPasswordData {
  code: string;
  password: string;
  confirmPassword: string;
}
